export default {
    regular: '400',
    medium: '500',
    demi: '600'
};
